import { Alert, Button, Col, Row, Space, Typography } from "antd";
import _ from "lodash";
import moment from "moment";
import { useMemo, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { getOrderMemoByOrderNo } from "../../../../../../apis/orderMemo";

import { dateFormat } from "../../../../../../shared/utils/Dates/format";
import color from "../../../../../../theme/color";
import { ArrowSmallLeft } from "../../../../Icon";
import { IconForm } from "../../../../Icon/index.styled";
import { CustomCard } from "../../../Detail/Card.styled";
import { Section } from "../../index.styled";
import { RepairCsMemoHistoryDrawer } from "./History";

interface RepairCsMemoInfoFormProps {
  repairNo?: string;
}

/**
 * 매장주문 > 고객센터메모
 * @param param0
 * @returns
 */
export const RepairCsMemoInfoForm: React.FC<RepairCsMemoInfoFormProps> = ({
  repairNo,
}) => {
  const queryClient = useQueryClient();

  const [open, setOpen] = useState(false);
  const [ellipsis, setEllipsis] = useState(true);

  const { data } = useQuery(
    ["OM", repairNo, "CsMemo"],
    () => getOrderMemoByOrderNo(repairNo as string),
    {
      enabled:
        !!repairNo && !queryClient.getQueryData(["OM", repairNo, "CsMemo"]),
      refetchOnMount: "always",
      refetchInterval: 1000 * 60 * 5,
      select: (data) => data?.rows?.filter((item) => item.repairShopViewable),
    }
  );

  const lastMemo = useMemo(
    () => (data ? _.orderBy(data, "createdAt", "desc")?.[0] : undefined),
    [data]
  );

  return (
    <>
      <Section style={{ padding: 0 }}>
        <CustomCard
          bordered={false}
          title={
            <Typography.Title level={5} style={{ fontSize: 17 }}>
              최신메모
            </Typography.Title>
          }
          headStyle={{ padding: "8px 20px", borderBottomWidth: 0 }}
          bodyStyle={{ padding: "0 20px 20px" }}
          {...(!!data?.length && {
            extra: (
              <Button
                type="text"
                style={{ color: color.gray4, padding: 0 }}
                onClick={() => setOpen(true)}
              >
                <Space align="center" size={4}>
                  더보기
                  <IconForm
                    component={ArrowSmallLeft}
                    color={color.gray4}
                    style={{ fontSize: 10, lineHeight: "20px" }}
                    rotate={180}
                  />
                </Space>
              </Button>
            ),
          })}
        >
          <Row>
            {lastMemo && (
              <Col span={24}>
                <Alert
                  onClick={() => {
                    setEllipsis((prev) => !prev);
                  }}
                  message={
                    <Row
                      gutter={6}
                      wrap={false}
                      align="top"
                      style={{ width: "100%" }}
                    >
                      <Col flex="auto">
                        <Typography.Paragraph
                          style={{
                            color: color.gray2,
                            margin: 0,
                            fontSize: 15,
                            fontWeight: 400,
                            lineHeight: "20px",
                            whiteSpace: !ellipsis ? "pre-wrap" : undefined,
                          }}
                          ellipsis={
                            ellipsis
                              ? {
                                  expandable: false,
                                  rows: 1,
                                }
                              : false
                          }
                        >
                          {lastMemo?.orderMemo}
                        </Typography.Paragraph>
                      </Col>

                      <Col flex="none">
                        <IconForm
                          component={ArrowSmallLeft}
                          style={{ fontSize: 12 }}
                          rotate={ellipsis ? 270 : 90}
                        />
                      </Col>
                    </Row>
                  }
                  description={
                    <Typography.Text
                      style={{ color: color.gray4, fontSize: 13 }}
                    >
                      {dateFormat(
                        moment(lastMemo?.createdAt),
                        "YYYY.MM.DD HH:mm"
                      )}
                    </Typography.Text>
                  }
                  style={{
                    background: color.primary10,
                    borderColor: color.primary10,
                  }}
                  closable={false}
                />
              </Col>
            )}
            {lastMemo === undefined && (
              <Col
                span={24}
                style={{ display: "inline-flex", justifyContent: "center" }}
              >
                <Typography.Text style={{ color: color.gray5 }}>
                  작성된 메모가 없어요
                </Typography.Text>
              </Col>
            )}
          </Row>
        </CustomCard>
      </Section>
      <RepairCsMemoHistoryDrawer
        visible={open}
        dataSource={data}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
